// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".promotion-event{display:flex;flex-direction:column}.product-price{min-height:26px}.promo-event{margin-top:2px}.promo-event .promo-event__info{margin-top:1px;font-size:9px;text-align:right}.promo-event .promo-event__left{float:left}@media (min-width:1024px){.promo-event .promo-event__info{font-size:11px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
